var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightCertifried(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4426 20.2624H4.77045V5M4.77045 5V2.67221C4.77045 1.66533 3.95766 0.852539 2.95078 0.852539C1.94389 0.852539 1.1311 1.66533 1.1311 2.67221V5H4.77045Z",
    stroke: "#368FEF",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95068 0.852539H18.1146C19.1215 0.852539 19.9343 1.66533 19.9343 2.67221V20.2624H17.5081",
    stroke: "#368FEF",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2951 19.0493V23.9018L14.4754 22.6887L12.6558 23.9018V19.0493",
    stroke: "white",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5082 16.6231C17.5082 18.2972 16.1495 19.6559 14.4754 19.6559C12.8013 19.6559 11.4426 18.2972 11.4426 16.6231C11.4426 14.949 12.8013 13.5903 14.4754 13.5903C16.1495 13.5903 17.5082 14.949 17.5082 16.6231Z",
    stroke: "white",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80322 8.13086H16.9016",
    stroke: "white",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80322 10.5576H13.2622",
    stroke: "white",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80322 5.70508H16.9016",
    stroke: "white",
    strokeWidth: 1.21311,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCertifried);
export default __webpack_public_path__ + "static/media/light_certifried.fe0debc90367e3fa1716bfaba9bfe950.svg";
export { ForwardRef as ReactComponent };